import * as React from 'react';

import { ChevronIcon } from '@icons';

import { config } from '@/config.ts';

import * as Styled from './button.styled';
import { ICON_POSITION } from './types';

export type ButtonProps = {
	hasIcon?: boolean;
	color?: Styled.ButtonElementProps['$color'];
	size?: Styled.ButtonElementProps['$size'];
	mobileSize?: Styled.ButtonElementProps['$size'];
	variant?: Styled.ButtonElementProps['$variant'];
	iconPosition?: Styled.ButtonElementProps['$iconPosition'];
	fluid?: boolean;
	onClick?: React.MouseEventHandler;
	disabled?: boolean;
	tabIndex?: number;
	className?: string;
	minWidth?: number;
};

type OwnProps = ButtonProps;

const ButtonComponent: React.ForwardRefRenderFunction<HTMLButtonElement, React.PropsWithChildren<OwnProps>> = (
	{
		hasIcon,
		iconPosition = 'end',
		children,
		color = 'neutral',
		size = 'medium',
		mobileSize,
		variant,
		fluid,
		onClick,
		disabled,
		tabIndex,
		className,
		minWidth
	},
	ref
) => {
	// Set default variant for non-PM brands
	const isPmBrand = config.BRAND === 'pm';
	const defaultVariant = !isPmBrand ? 'round' : variant;

	return (
		<Styled.ButtonElement
			disabled={disabled}
			onClick={onClick}
			tabIndex={tabIndex}
			$hasText={!!children}
			$hasIcon={hasIcon}
			ref={ref}
			$color={color}
			$size={size}
			$variant={defaultVariant}
			$fluid={fluid}
			$minWidth={minWidth}
			className={className}
			$mobileSize={mobileSize}
		>
			{hasIcon && iconPosition === ICON_POSITION.START && (
				<Styled.IconWrapper>
					<ChevronIcon />
				</Styled.IconWrapper>
			)}

			{children && <Styled.TextWrapper>{children}</Styled.TextWrapper>}

			{hasIcon && iconPosition === ICON_POSITION.END && (
				<Styled.IconWrapper>
					<ChevronIcon.Right />
				</Styled.IconWrapper>
			)}
		</Styled.ButtonElement>
	);
};

export const Button = React.forwardRef(ButtonComponent);
